import React from "react";
import Page, { PageProps } from "../Page";
import DataGrid from "../../components/app/grid/DataGrid";
import { Form } from "antd";
import { IFactsPresenter } from "../../../presenter/evaluation/FactsPresenter";
import CreateFactForm, { CreateFactFormProps } from "./CreateFactForm";
import { FactDataTypes } from "../../../model/evaluation/Fact";
import UpdateFactForm, { UpdateFactFormProps } from "./UpdateFactForm";
import Loader from "../../components/Loader";
export interface Props extends PageProps {}
export interface State extends IFactsPresenter {}

export default class FactsPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let { translate, facts = [], createFact, updateFact } = this.state;
    const CreateForm = Form.create<CreateFactFormProps>({})(CreateFactForm);

    const UpdateForm = Form.create<UpdateFactFormProps>({})(UpdateFactForm);

    const columns = [
      {
        title: translate("facts_page.name"),
        dataIndex: "name",
        key: "name"
      },

      {
        title: translate("facts_page.dataType"),
        key: "dataType",
        render: (text, record) => {
          return (
            <span>
              {translate(
                `fact_form.data_type_${record.dataType.toLowerCase()}`
              )}
            </span>
          );
        },
        sorter: (a, b) => {
          return String(a.dataType).localeCompare(String(b.dataType));
        }
      },
      {
        title: translate("facts_page.description"),
        dataIndex: "description",
        key: "description"
      }
    ];

    const dataGrid = (
      <DataGrid
        title={translate("grids.facts")}
        translate={translate}
        columns={columns}
        dataSource={facts}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        createForm={CreateForm}
        updateForm={UpdateForm}
        onCreate={createFact}
        onUpdate={updateFact}
        codebooks={{
          factDataTypes: FactDataTypes
        }}
        expandedRowRender={record => (
          <p
            style={{
              margin: 0,
              fontFamily: "Courier New",
              whiteSpace: "pre-wrap"
            }}
          >
            {record.sqlExpression}
          </p>
        )}
        createModalTitle={translate("facts_page.insert_modal_title")}
        updateModalTitle={translate("facts_page.update_modal_title")}
        addButtonText={translate("facts_page.add_button_text")}
      />
    );

    return (
      <Page {...this.props}>
        <Loader
          children={dataGrid}
          translate={translate}
          loading={this.state.loaders.factsLoader}
        />
      </Page>
    );
  }
}
